// extracted by mini-css-extract-plugin
export default {"summary":"index_summary_182vP","cRed":"index_cRed_mF0fF"};